module.exports = __webpack_public_path__ + "img/trustpilot.e452c29e.png";